import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { NgxImageCompressService } from "ngx-image-compress";
import { CrudWImageForm } from "src/app/components/shared/cruds/crud-w-image.form";
import { TiposMaterialDTO } from "src/app/models/tipo-material.dto";
import { CURP_REGEX, GUID_ZERO } from "src/app/utils/constants";
import { BlackListService } from "../../blacklist/blacklist.service";
import { OperadoresService } from "../operadores.service";
import * as dayjs from "dayjs";

@Component({
  selector: "app-form-drawer-blacklist",
  templateUrl: "./drawer-form.component.html",
})
export class TrabajadorDrawerForm
  extends CrudWImageForm<TiposMaterialDTO>
  implements OnInit
{
  public curpRegex = CURP_REGEX;
    public curpValidating = false;
  public curpGood = false;
  public curpBad = false;
  public curpNeedValidate = true;
  public waiting = false;
  error_curp: string;
  drawerRef: any;
  data?: {
    mode: "create" | "update";
    value: any;
  };
  constructor(
    public fb: FormBuilder,

    public service: OperadoresService,
    public serviceBlack: BlackListService,
    private compress: NgxImageCompressService,
  ) {
    super(fb, compress);
  }
  public ngOnInit(): void {
    this.buildForm();
    if (this.data) {
      this.defaults = this.data.value;
      if (this.data.mode === "update") {
        this.setUpdate(this.data.value);
      } else {
        this.setCreate();
        this.valueImg = null;
      }
    }
  }

  // TODO add validators
  public buildForm() {
    this.form = this.fb.group({
      IdTrabajador: [""],
      Telefono: [""],
      Correo: [""],
      Direccion: [""],
      FechaIngreso: [""],
      FechaSalida: [""],

      ApellidoPaterno: [""],
      ApellidoMaterno: [""],
      NombreSS: ["", [Validators.required]],
      Sexo: [""],
      FechaNacimiento: [""],
      LugarNacimiento: [""],
      CURP: ["", [Validators.required, Validators.pattern(this.curpRegex)]],
      NSS: [""],
      RFC: [""],
      Infonavit: [""],
      Puesto: [""],
      Salario: [""],
      Tipo: [3, [Validators.required]],
    });
  }
  public fromInit(row: any) {
       this.defaults = row;
       this.form.controls["IdTrabajador"].setValue(this.defaults?.IdTrabajador);
       this.form.controls["Telefono"].patchValue(this.defaults?.Telefono);
       this.form.controls["Correo"].patchValue(this.defaults?.Correo);
       this.form.controls["Direccion"].patchValue(this.defaults?.Direccion);
       this.form.controls["FechaIngreso"].patchValue(
         this.defaults.FechaIngreso
           ? dayjs(this.defaults.FechaIngreso).format("YYYY-MM-DD")
           : null
       );
       this.form.controls["FechaSalida"].patchValue(
         this.defaults.FechaSalida
           ? dayjs(this.defaults.FechaSalida).format("YYYY-MM-DD")
           : null
       );
       this.form.controls["ApellidoPaterno"].patchValue(
         this.defaults?.ApellidoPaterno
       );
       this.form.controls["ApellidoMaterno"].patchValue(
         this.defaults?.ApellidoMaterno
       );
       this.form.controls["NombreSS"].patchValue(this.defaults?.NombreSS);
       this.form.controls["Sexo"].patchValue(this.defaults?.Sexo);
       this.form.controls["LugarNacimiento"].patchValue(
         this.defaults?.LugarNacimiento
       );
       this.form.controls["CURP"].patchValue(this.defaults?.CURP);
       this.form.controls["NSS"].patchValue(this.defaults?.NSS);
       this.form.controls["RFC"].patchValue(this.defaults?.RFC);
       this.form.controls["Infonavit"].patchValue(this.defaults?.Infonavit);
       this.form.controls["Puesto"].patchValue(this.defaults?.Puesto);
       this.form.controls["Salario"].patchValue(this.defaults?.Salario);
       this.form.controls["Tipo"].patchValue(this.defaults?.Tipo);
       this.form.controls["FechaNacimiento"].patchValue(
         this.defaults.FechaNacimiento
           ? dayjs(this.defaults.FechaNacimiento).format("YYYY-MM-DD")
           : null
       );
       this.curpGood = true;
       this.curpNeedValidate = false;
       this.loadImage();
       this.waiting = false;
  }

  public loadImage() {
    this.service.image(this.defaults.IdTrabajador).subscribe(
      (str) => (this.valueImg = str),
      (err) => (this.valueImg = null),
    );
  }

  public saveOver() {
    this.drawerRef.close({
      valid: this.form.invalid,
      data: {
        mode: this.mode,
        value: this.form.value,
        file: this.imageFile,
      },
    });
  }

  imageFile: File | null = null;

  onImageSelected(file: File | null) {
    this.imageFile = file;
  }

  validateCurp() {
    this.curpValidating = true;
    this.curpNeedValidate = false;
    const c = this.form.value.CURP;
    this.serviceBlack
      .validate(c, this.defaults?.IdTrabajador ?? GUID_ZERO)
      .subscribe(
        (d: any) => {
          if (d.fail) {
            if (d.msg == "blacklist") {
              this.error_curp =
                "La curp existe en el registro de no recomendados";
            } else if (d.msg == "regex") {
              this.error_curp = "La curp tiene formato invalido";
            } else if (d.msg == "dup") {
              const location =
                d.location == "actives"
                  ? "Activos"
                  : d.location == "inactives"
                    ? "Bajas"
                    : "No Reingreso";
              this.error_curp = `La curp pertenece a ${d.nombre}, en el listado ${location}`;
            } else {
              this.error_curp = "Error. Contacte a soporte.";
            }

            this.curpGood = false;
            this.curpBad = true;
          } else {
            this.curpGood = true;
            this.curpBad = false;
          }
          this.curpValidating = false;
        },
        (e) => {
          this.curpNeedValidate = true;
          this.curpValidating = false;
        },
      );
  }
  resetCurpValidation() {
    this.curpNeedValidate = true;
    this.curpValidating = false;
    this.curpGood = false;
    this.curpBad = false;
  }

  buttonDisable() {
    if (!this.form) return true;
    return !this.form.valid || !this.curpGood || this.waiting;
  }
}
